import React from 'react'
import "./color.css"

function RedUL() {
    var x = localStorage.getItem("percentage ulp")
    return (
        <div className = "red__backgroundul">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default RedUL
